export interface GetLatLngFromPlaceIdReturn {
  lat: number
  lng: number
}

export const getLatLngFromPlaceId = async (opts: {
  placeId: string
  sessionToken?: google.maps.places.AutocompleteSessionToken
}): Promise<GetLatLngFromPlaceIdReturn | null> => {
  const { placeId, sessionToken } = opts
  // warn and boot out if no placeId
  if (!placeId) {
    console.warn('getLatLngFromPlaceId called without a placeId')
    return null
  }

  // if we're not on the browser, we can't use google maps so console warn and return null
  if (!import.meta.client) {
    console.warn('getLatLngFromPlaceId called on server, returning null')
    return null
  }

  // get a new place service
  const placesService =
    window &&
    window.google &&
    window.google.maps &&
    new window.google.maps.places.PlacesService(document.createElement('div')) // No need for a visible map

  // if we don't have a places service, warn and return null
  if (!placesService) {
    console.warn('getLatLngFromPlaceId called without a valid google places service')
    return null
  }

  return new Promise<GetLatLngFromPlaceIdReturn>((resolve, reject) => {
    placesService.getDetails(
      {
        placeId,
        fields: ['geometry.location'], // Only fetch lat/lng to minimize cost
        // use the session token if we have one
        sessionToken
      },
      (place, status) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK || !place?.geometry?.location) {
          return reject(status)
        }
        resolve({
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        })
      }
    )
  })
}
